module.exports = "/images/bannerTwo-mobile.jpg";